import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Redirect to the static HTML app
    window.location.href = '/index.html';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      fontFamily: 'Space Grotesk, sans-serif'
    }}>
      <p>Loading 3D Print Colour Preview...</p>
    </div>
  );
}

export default App;
